import { atom } from "recoil";

const dateRangesAtom = atom({
  key: "dateRangesAtom",
  default: [],
});

export default dateRangesAtom;